import type { I18nKey } from "~/helpers/locale";

export default defineNuxtPlugin(() => {
  const { $i18n } = useNuxtApp();
  return {
    provide: {
      tt(key: I18nKey, options?: Record<string, unknown> | string[]) {
        return options ? $i18n.t(key, options as Record<string, unknown>) : $i18n.t(key);
      }
    }
  };
});